import { useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getDetectLive } from "../api/detect";
import { GetDetectLiveParams } from "../types/types";
import userStorage from "../utils/userStorage";

const useGetDetectLive = ({
  mobility_code = -1,
  searchKey = "",
  area,
  page,
  limit,
  swlng,
  swlat,
  nelng,
  nelat,
  startDate,
  endDate,
  event_code,
  groupId,
  runStat,
  isDetect,
}: GetDetectLiveParams & { isDetect?: boolean }) => {
  const location = useLocation();
  const user = userStorage.get();

  const { data, isSuccess, isLoading, isError, refetch } = useQuery({
    queryKey: isDetect
      ? ["Monitoring"]
      : [
          "DetectLive",
          `mobility_code: ${mobility_code}`,
          `searchKey: ${searchKey}`,
          `area: ${area}`,
          `page: ${page}`,
          `limit: ${limit}`,
          `swlng: ${swlng}`,
          `swlat: ${swlat}`,
          `nelng: ${nelng}`,
          `nelat: ${nelat}`,
          `startDate: ${startDate}`,
          `endDate: ${endDate}`,
          `event_code: ${event_code}`,
          `groupId: ${groupId}`,
          `runStat: ${runStat}`,
        ],
    queryFn: () =>
      getDetectLive({
        mobility_code,
        searchKey,
        area,
        page,
        limit,
        swlng,
        swlat,
        nelng,
        nelat,
        startDate,
        endDate,
        event_code,
        groupId,
        runStat,
      }),
    retry: false,
    enabled:
      location.pathname !== `/login` &&
      location.pathname !== `/maintenance` &&
      !!user,
    staleTime: 1000 * 10,
    refetchInterval: 1000 * 10,
  });

  return { data, isSuccess, isLoading, isError, refetch };
};

export default useGetDetectLive;
